import type { MouseEvent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/cn';

import type { ContentItemDbType } from './content-comment';

export const RelatedContentLink = ({
  contentType,
  contentTitle,
  onOpen,
  className,
}: {
  contentType: ContentItemDbType;
  contentTitle: string | null;
  onOpen: () => void;
  className?: string;
}): ReactNode => {
  const { t } = useTranslation('content');
  const typeLabel = t(`comments.contentType.${contentType}`);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onOpen();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        'max-w-full rounded-sm text-left text-brand hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand',
        className,
      )}
    >
      <span className="block truncate font-medium">{contentTitle ?? typeLabel}</span>
      {contentTitle ? (
        <span className="block truncate text-caption font-normal text-fg-secondary">{typeLabel}</span>
      ) : null}
    </button>
  );
};
